import React, { useState } from 'react';
import { Link, router } from '@inertiajs/react';

const inputClass =
  "block w-full rounded-lg border border-gray-200 bg-white px-3.5 py-2.5 text-sm text-gray-900 placeholder:text-gray-400 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 focus:outline-none transition";

export default function NabDomainForm({ nabDomain, mode }) {
  const [code, setCode] = useState(nabDomain.code || '');
  const [name, setName] = useState(nabDomain.name || '');
  const [submitting, setSubmitting] = useState(false);

  const isEdit = mode === 'edit';

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    const payload = { nab_domain: { code: code.trim(), name: name.trim() } };
    const options = { onFinish: () => setSubmitting(false) };
    if (isEdit) {
      router.patch(`/superadmin/nab_domains/${nabDomain.id}`, payload, options);
    } else {
      router.post('/superadmin/nab_domains', payload, options);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm space-y-5">
      <div>
        <label htmlFor="code" className="block text-sm font-semibold text-gray-700 mb-1.5">Code</label>
        <input
          type="text"
          id="code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          required
          autoFocus
          placeholder="e.g. 1A1"
          className={inputClass}
        />
        <p className="mt-1 text-xs text-gray-500">Short identifier (e.g. 1A1, 4B5). Must be unique.</p>
      </div>

      <div>
        <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-1.5">Name</label>
        <input
          type="text"
          id="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          placeholder="e.g. Medical and Nursing Care Practices"
          className={inputClass}
        />
      </div>

      <div className="flex flex-col-reverse sm:flex-row gap-3 pt-2">
        <Link
          href="/superadmin/nab_domains"
          className="flex-1 inline-flex items-center justify-center rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm font-semibold text-gray-700 hover:bg-gray-50 transition"
        >
          Cancel
        </Link>
        <button
          type="submit"
          disabled={submitting}
          className="flex-1 inline-flex items-center justify-center gap-2 rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed transition cursor-pointer"
        >
          {submitting ? 'Saving…' : isEdit ? 'Save changes' : 'Create domain'}
        </button>
      </div>
    </form>
  );
}
